export default {
  pleaseSelect:'請選擇'
};
